import { newWin } from '@/utils/index.js';
export default {
  data() {
    return {
      youlian: [{
        title: '品牌设计',
        link: 'https://www.staerlined.com'
      }, {
        title: '版权保护',
        link: 'https://vlian.cn/copyright'
      }, {
        title: '内容制作',
        link: 'http://www.tvzone.cn/'
      }]
    };
  },
  methods: {
    toHelp(index) {
      let routeInfo = this.$router.resolve({
        path: '/article/' + index
      });
      newWin(routeInfo.href);
    }
  }
};